export default {
    // "m" stand for "message"
    m: {
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        save: 'Salvar',
        success: 'Sucesso',
        tip: 'Prompt',
        operateSuccess: 'Operado com sucesso!',
        addSuccess: 'Adicionado com sucesso!',
        editSuccess: 'Modificado com sucesso!',
        delSuccess: 'Apagado com sucesso!',
        importSuccess: 'Importação bem sucedida!',
        importFail: 'Falha na importação!',
        saveSuccess: 'Salvo com sucesso!',
        delete: 'Tem certeza de que deseja excluir isso?',
        edit: 'Tem certeza de que deseja editar isso?',
        publish: 'Tem certeza de lançar este programa de treinamento?',
        resetPwd: 'Tem certeza de que redefinir a senha do usuário? Após a redefinição, a senha será alterada para: ',
        coursingOrExit: 'O material do curso está sendo produzido. Tem certeza que deseja sair?',
        paperingOrExit: 'O documento de exame está sendo produzido. Tem certeza que deseja sair?',
        paperDataNotSave: 'Os dados atuais do documento de exame não serão salvos. Confirmar para continuar?',
        delCert: 'Isso excluirá permanentemente o certificado. Deseja continuar?',
        titleRequired: 'O título não pode estar vazio!',
        submitPaper: 'Tem certeza de enviar o documento de teste?',
        submitUndonePaper: 'Você ainda tem {0} perguntas que não foram respondidas, tem certeza de enviar o documento de teste?',
        practiceResult: 'Este exercício contém um total de {0} perguntas e você respondeu {1} perguntas corretamente',
        endingTime: 'A data de obtenção do certificado não deve ser inferior à data de emissão do certificado',
        checkCode: 'O código de verificação foi enviado para o seu celular, verifique-o',
        signOut: 'Você tem certeza de sair?',
        cycleUser: 'Você tem certeza de reciclar o usuário selecionado?',
        deleteUser: 'Tem certeza de que deseja excluir permanentemente o usuário selecionado?',
        pleaseComplete: 'Por favor, complete o formulário!',
        emptyMenuLogin: 'Por favor, configure os dados do menu para esta conta primeiro!',
        startExam: 'Você tem certeza de iniciar o exame?',
        startResitExam: 'Você tem certeza de iniciar o exame complementar?',
        deleteImg: 'Tem certeza de que deseja excluir esta/estas {0} imagem/imagens?',
        resit1: 'Você tem certeza de adicionar outro exame de maquiagem?',
        resit2: 'Este exame foi autorizado a repetir {0} vezes. Tem certeza de que adicionou outra repetição?'
    },
    // "c" stand for "common" 各个组件公共的词条
    c: {
        all: 'Todos',
        back: 'Retorno',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        reset: 'Reset',
        success: 'Sucesso',
        operation: 'Operação',
        close: 'Fechar',
        save: 'Salvar',
        input: 'Entrada',
        add: 'Adicionar',
        delete: 'Excluir',
        edit: 'Editar',
        query: 'Consulta',
        view: 'Ver',
        preview: 'Pré-visualização',
        publish: 'Publicar',
        unpublish: 'Despublicar',
        share: 'Compartilhar',
        select: 'Selecionar',
        submit: 'Enviar',
        finish: 'Concluir',
        others: 'Outros',
        settings: 'Configurações',
        show: 'Mostrar',
        size: 'Tamanho',
        total: 'Total',
        to: 'Para',
        prev: 'Anterior',
        next: 'Próximo',
        fail: 'Falhou',
        yes: 'Sim',
        no: 'Não',
        NO: 'No.',
        none: 'Nenhum',
        type: 'Tipo',
        status: 'Status',
        description: 'Descrição',
        video: 'Vídeo',
        audio: 'Áudio',
        image: 'Imagem',
        theory: 'Teoria',
        document: 'Documento',
        logOut: 'Sair',
        date: 'Duração',
        from: 'A partir de',
        startTime: 'Hora de início',
        endTime: 'Hora de término',
        startDate: 'Data de início',
        endDate: 'Data de término',
        creator: 'Criador',
        creationTime: 'Tempo de criação',
        makingTime: 'Tempo de produção',
        modificationTime: 'Tempo de modificação',
        modificationBy: 'Modificador',
        noData: 'Nenhum dado disponível agora',
        noMore: 'Não mais',
        difficulty: 'Dificuldade',
        knowledgePoint: 'Ponto de conhecimento',
        operatorLevel: 'Nível aplicável',
        organizations: 'Organizações',
        belong: 'Instituição afiliada',
        trainingType: 'Tipo de treinamento',
        examType: 'Forma de exame',
        position: 'Posição',
        occupation: 'Tipo de identidade',
        userInfo: 'Informações pessoais',
        name: 'Nome',
        username: 'Nome',
        gender: 'Sexo',
        phone: 'Número de celular',
        role: 'Função subordinada',
        grade: 'Habilidade',
        education: 'Qualificação acadêmica',
        birthday: 'Data de nascimento',
        idCardNo: 'Número de identificação',
        idNo: 'Número de trabalho',  //jobNo
        account: 'Número de conta',  //accountNo
        downTemplate: 'Baixar modelo',
        import: 'Importar',
        male: 'Masculino',
        female: 'Feminino',
        desc: 'Descrição',
        coursewareLibrary: 'Biblioteca de cursos',
        producer: 'Produtor',
        productionDate: 'Data de produção',
        modify: 'Modificar',
        making: 'Produção',
        resourceName: 'Nome de recurso',
        problemNo: 'Número de pergunta',
        right: 'Certo',
        wrong: 'Errado',
        error: 'Erro',
        notAvailable: 'Não disponível',
        detail: 'Detalhes',
        option: 'Opções',
        check: 'Selecione',
        noticeHoverTitle: 'Notificação de mensagem',
        noticeTitle: 'Notificação',
        noticeNone: 'Sem aviso prévio',
        noticeClear: 'Limpar notificação',
        upTrend: 'Tendência de upload (quase um mês)',
        trainAnalyse: 'Análise de dados de tarefas de treinamento (quase um mês)',
        quickEntry: 'Entrada rápida',
        seeMore: 'Veja mais ',
        trainFinish: 'Conclusão do plano de treinamento',
        toEnd: 'Termina em',
        day: 'Dia',
        hour: 'Hora',
        viewDetail: 'Ver detalhes',
        recentWeek: 'Semana recente',
        miles: 'Metros',
        open: 'Aberto',
        exam: 'Exame',
        practice: 'Prática',
        learn: 'Aprendizagem',
        completeTime: 'Tempo de conclusão',
        notYet: 'Ainda não',
        notGet: 'Nenhum',
        lookForward: 'No desenvolvimento, fique atento ...',
        yearTime: 'Ano',
        employmentDate: 'Horário de entrada',
        imageLearn:'Image learned',
        studyTime:'Total study time',
        learningStatistics:'Estatísticas de amor.',
        exportLearnStats:'Estatísticas de educação',
        clear:'Seleção clara',
        moment: 'há um momento atrás',
        yearAgo: 'ano atrás',
        monthAgo: 'mês atrás',
        weekAgo: 'semanas atrás',
        dayAgo: 'dia atrás',
        hourAgo: 'hora atrás',
        minuteAgo: 'minuto atrás',
        month: 'minuto',
        unset: 'unset',
    },
    tip: {
        select: 'Por favor, selecione',
        input: 'Por favor, digite o conteúdo',
        name: 'Por favor, digite o nome',
        sysName: 'Por favor, digite o nome do sistema',
        sysEnName: 'Por favor, digite o nome do sistema em inglês ',
        sysShortName: 'Por favor, digite o nome abreviado do sistema',
        sysVersion: 'Por favor, digite a versão do sistema',
        knowledgePoint: 'Por favor, selecione um ponto de conhecimento',
        operatorLevel: 'Por favor, selecione o nível aplicável',
        belong: 'Por favor, selecione a instituição afiliada',
        trainingType: 'Por favor, selecione o tipo de treinamento',
        examType: 'Por favor, selecione a forma de exame',
        orgName: 'Por favor, digite o nome da instituição',
        userSearch: 'Por favor, digite o nome, número de conta',
        userSearchPlus: 'Por favor, digite o nome, número de conta, número de celular',
        username: 'Por favor, digite o nome de usuário',
        usernameOrNo: 'Por favor, digite o nome de usuário ou número',
        usernameOrAccount: 'Por favor, digite o nome de usuário ou número de conta',
        idNo: 'Por favor, digite o número de trabalho',
        occupation: 'Por favor, selecione um tipo de identidade',
        grade: 'Por favor, selecione habilidades',
        position: 'Por favor, selecione uma posição',
        gender: 'Por favor, selecione sexo',
        birthday: 'Por favor, selecione a data de nascimento',
        idCardNo: 'Por favor, digite o número de identificação',
        education: 'Por favor, escolha a qualificação acadêmica',
        path: 'Por favor, digite o nome de rota',
        icon: 'Por favor, digite o nome da classe do ícone',
        NO: 'Por favor, digite o número de série',
        remark: 'Por favor, insira uma nota',
        time: 'Por favor, selecione a hora',
        date: 'Por favor, selecione uma data',
        datetime: 'Selecione data e hora',
        startTime: 'Selecione a data de início',
        endTime: 'Selecione a data de término',
        employmentDate: 'Escolha a hora de participar',
        reason: 'Por favor, selecione o motivo',
        courseName: 'Por favor, digite o nome de curso',
        producer: 'Por favor, digite o produtor',
        courseType: 'Por favor, selecione um tipo de material didático',
        hours: 'Por favor, digite o horário de aula',
        credits: 'Por favor, digite créditos',
        addImg: 'Por favor, adicione uma imagem',
        problemNo: 'Por favor, digite o número de pergunta',
        creator: 'Por favor, digite o criador',
        difficulty: 'Por favor, selecione o nível de dificuldade',
        titleDesc: 'Por favor, digite uma descrição do tópico',
        chooseRightAnswer: 'Por favor, escolha a resposta correta',
        optionDesc: 'Por favor, preencha a descrição da opção',
        paperName: 'Por favor, digite o nome do documento de exame',
        paperGroupType: 'Por favor, selecione o modo de composição de documento de teste',
        passLine: 'Por favor, insira a linha de passe',
        questionScore: 'Por favor, insira a pontuação de pergunta do exame',
        paperType: 'Por favor, digite o tipo do documento de exame',
        paperForm: 'Por favor, digite o formulário do documento de exame',
        perspective: 'Por favor, escolha uma perspectiva',
        account: 'Por favor, digite o número de conta',
        trainerName: 'Por favor, digite o nome do aluno',
        transcriptTitle: 'Por favor, digite o título de transcrição',
        word: 'Por favor, digite o texto',
        title: 'Por favor, insira um título',
        option: 'Por favor, digite o conteúdo da opção',
        trainName: 'Por favor, digite o nome do programa de treinamento',
        oldPwd: 'Por favor, digite a senha antiga',
        newPwd: 'Por favor, digite a senha nova',
        confirmPwd: 'Por favor, digite a senha nova novamente',
        mobile: 'Por favor, digite o número de celular',
        code: 'Por favor, digite o código de verificação',
        untie: 'Por favor, digite o código de verificação de celular para desvincular',
        chooseGroupType: 'O tipo de CT não suporta a composição de documento de teste rápida, por favor, selecione o modo novamente ',
        txtContent: 'Área de conteúdo ...',
        resName: 'Por favor, digite o nome de recurso',
        imgUploadMaxSize: 'O tamanho da imagem não pode exceder {0} M',
        fileUploadMaxSize: 'O tamanho do arquivo não pode exceder {0} M',
        fileExceedTip: 'Atualmente restrito para selecionar {0} arquivos, desta vez {1} arquivos são selecionados, um total de {2} arquivos são selecionados',
        chooseOrgFirst: 'Por favor, selecione uma organização primeiro',
        queryOrg: 'Organização de consulta',
        chooseDueDate: 'Por favor, selecione o prazo',
        chooseTopicSource: 'Por favor, selecione a fonte de pergunta',
        uploader: 'Digite o carregador',
        knowTagTip: 'Digite um rótulo',
        knowTypeTip: 'Por favor, selecione o tipo de conhecimento',
        knowNameTip: 'Digite o nome do conhecimento',
        knowDescTip: 'Digite uma descrição do conhecimento',
        tipStart:'Selecione uma hora de início',
        tipEnd:'Selecione um horário de término',
        type: 'Por favor escolha o tipo',
    },
    rule: {
        lengthBetween: 'Comprimento entre {0} e {1} caracteres',
        maxLength: 'Não pode exceder {0} caracteres',
        idCardNo: 'Por favor, digite o número de identificação correto',
        required: 'Por favor, preencha este item',
        int: 'O valor não pode ser um decimal',
        time: 'A hora é necessariamente posterior à hora atual',
        pwd: 'Regras de senha: 12 a 20 dígitos, uma combinação de números, letras e certos caracteres especiais _-#@&?*^=!.$%',
        pwdError: 'Não atenda às regras de senha, preencha novamente',
        mobileNotExist: 'O número de celular não existe!',
        mobileHasBound: 'O número foi vinculado a outra conta',
        modifyPwd:'Por favor, mude a senha!',
        codeError: 'Apenas _-#@&?*^=!.$% é suportado Outros caracteres especiais',
    },
    system: {
        sysName: 'Nome do sistema',
        sysEnName: 'Nome do sistema em inglês ',
        sysShortName: 'Nome abreviado do sistema',
        sysVersion: 'Versão do sistema',
        sysLogo: 'Logotipo do sistema',
        editSysLogo: 'Modificar logotipo do sistema',
        addOrg: 'Nova instituição adicionada',
        orgDetail: 'Detalhes da organização',
        orgName: 'Nome da organização',
        orgDesc: 'Descrição da organização',
        addUser: 'Adicionar usuário',
        importUser: 'Importar usuário',
        editUser: 'Modificar usuário',
        cycleUser: 'Restaurar usuário',
        recoverUser: 'Restaurar usuário',
        deleteUser: 'Excluir usuário',
        modifyRole: 'Modificar função',
        manageRole: 'Gerenciar função',
        addRole: 'Adicionar função',
        delRole: 'Excluir função',
        resetPwd: 'Redefinir senha',
        unselected: 'Não selecionado',
        selected: 'Selecionado',
        changeAvatar: 'Mudar meu retrato',
        userProfile: 'Perfis de usuário',
        trainRecord: 'Registro de treinamento',
        skillRecord: 'Identificação de habilidades',
        result: 'Resultado',
        certificateName: 'Nome do certificado',
        certAdd: 'Adicionar certificado',
        certDetail: 'Detalhes do certificado',
        certificateNo: 'Número do certificado',
        level: 'Nível de classificação',
        operateScore: 'Pontuação operacional',
        theoryScore: 'Realização teórica',
        releaseDate: 'Data de emissão',
        editMenu: 'Modificar menu',
        addMenu: 'Adicionar menu',
        addSubmenu: 'Adicionar submenu',
        parent: 'Anterior',
        path: 'Rota',
        icon: 'Ícone',
        roleName: 'Nome da função',
        manageMember: 'Configurar membros',
        manageMenu: 'Configurar menus',
        allMembers: 'Todos os membros',
        memberList: 'Lista de membros',
        selectedMember: 'Membros selecionados',
        theoryKnowledge: 'Ponto de conhecimento teórico',
        imageKnowledge: 'Conhecimento de imagem',
        remark: 'Observações',
        exportUser: 'Exportar usuário (com base nos critérios de filtro acima)',
        preJobApproval: 'Liberar dever para delegar',
        capabilityAnalyse: 'Gráfico de análise de capacidade',
        enabled: 'Ativo',
        disabled: 'Desativado',
        projectType: 'Categoria do projeto',
        importOrg: 'Importar organização',
        exportOrg: 'Exportar organização',
        move: 'Móvel'
    },
    user: {
        basicInfo: 'Informação básica',
        postInfo: 'Informação de trabalho',
        experienceInfo: 'Experiência de trabalho',
        trainInfo: 'Registro de treinamento',
        qualityInfo: 'Qualidade registro de controle',
        rewardInfo: 'Informações sobre recompensa e punição',
        modifyInfo: 'Modificar registro',
        importDiploma: 'Importar fotos do certificado de graduação',
        exportBasicInfo: 'Exportar informações básicas',
        exportExtendInfo: 'Detalhes de exportação',
        userImportTemplate: 'Modelo de importação de usuário',
        userBasicImportTemplate: 'Modelo de informações básicas do usuário',
        userExtendImportTemplate: 'Modelo de detalhes do usuário',
        zipImportTemplate: 'Modelo de pacote compactado',
        clickToDownload: 'Clique para baixar',
        chooseToDownload: 'Escolha um dos seguintes modelos para baixar:',
        startImport: 'Iniciar envio',
        unbind: 'Unbound',
        bindTip: 'Necessário vincular pelo usuário\n',
        nation: 'Nação',
        hometown: 'Hometown',
        currentAddress: 'Endereço residencial atual',
        graduationSchool: 'Escola graduada',
        graduationDate: 'Data de Graduação',
        graduationDateTip: 'Selecione a data de formatura',
        jobDate: 'Tempo de participação no trabalho',
        jobDateTip: 'Selecione o horário de trabalho',
        securityCheckJobDate: 'Horário de trabalho para inspeção de segurança',
        securityCheckJobDateTip: 'Por favor escolha',
        employmentDate: 'Tempo de entrada',
        employmentDateTip: 'Por favor escolha',
        diplomaPicture: 'Certificado de graduação e fotos de graduação',
        downloadFile: 'Baixar anexos',
        duty: 'Posição',
        jobTitle: 'Titulo do trabalho',
        backgroundReview: 'Revisão de fundo',
        certTip: 'Necessidade de adicionar um certificado para esse usuário em "Gerenciamento de certificados"',
        startEndTime: 'Horário de início e término',
        companyName: 'Nome da empresa',
        addWorkExperience: 'Nova experiência de trabalho',
        editWorkExperience: 'Experiência de trabalho editorial',
        addQuality: 'Adicionar registros de controle de qualidade',
        editQuality: 'Modificar registros de controle de qualidade',
        cause: 'Causa',
        dealResult: 'Resultado',
        addReward: 'Adicionadas informações de recompensa e punição',
        editReward: 'Editar informações de recompensa e punição',
        rewardDetail: 'Recompensas e punições específicas',
        punish: 'Punição',
        reward: 'Recompensa',
        module: 'Módulo',
        ledgerRecord: 'Gestão Da conta',
    },
    train: {
        name: 'Nome de treinamento',
        type: 'Categoria de treinamento',
        percent: 'Progresso de treinamento',
        memberNum: 'Número de estagiários',
        site: 'Local de treinamento',
        classHour: 'Hora de aula de treinamento',
        classScore: 'Créditos de treinamento',
        content: 'Conteúdo de treinamento',
        time: 'Tempo planejado',
        checkInTime: 'Hora de check-in',
        preTime: 'Tempo de pré-lançamento',
        dueTime: 'Prazo',
        addOnlineTrain: 'Novo treinamento online adicionado',
        addOfflineTrain: 'Novo treinamento offline adicionado',
        associatePaper: 'Associar questionário',
        choosePaper: 'Selecionar questionário',
        paperName: 'Nome do questionário',
        surveyName: 'Nome do questionário',
        confirmPublish: 'Você tem certeza de publicar?',
        newOnlineTraining: 'Desenvolver um programa de treinamento online',
        newOfflineTraining: 'Desenvolver um programa de treinamento offline',
        editTraining: 'Modificar o plano de treinamento',
        basicInfo: 'Informação básica',
        trainees: 'Participante',
        courseSystem: 'Sistema de curso',
        chooseCourse: 'Selecionar material didático',
        chooseTestPaper: 'Escolhar documento de teste',
        chooseMockPaper: 'Escolhar exame simulado',
        chooseTip: 'Adicione processos',
        testPeriod: 'Digite a duração do exame',
        editPaperTip: 'Edite o documento do exame',
        addSuccess: 'O programa de treinamento foi adicionado com sucesso!',
        editSuccess: 'O plano de treinamento foi revisado com sucesso!',
        trainDetail: 'Detalhes do plano de treinamento',
        trainTrace: 'Conclusão do treinamento',
        planDetail: 'Detalhes do registro de treinamento',
        progress: 'Progresso atual',
        progressNow: 'Progresso atual da conclusão',
        delTrainee: 'Remover essa pessoa do programa',
        delTraineeConfirm: 'Você tem certeza de remover {0} do programa de treinamento?',
        addTrainee: 'Adicionar treinadores',
        reason: 'Razão',
        absentReason: 'Razão de ausência',
        casualLeave: 'Despedida casual',
        sickLeave: 'Licença médica ',
        annualLeave: 'Férias anuais',
        parentalLeave: 'Licença parental',
        maternityLeave: 'Licença maternidade',
        paternityLeave: 'Licença de paternidade',
        passiveFinish: 'Conclusão passiva',
        credit: 'Crédito',
        hour: 'Hora da aula',
        times: 'Vezes',
        resitTimes: 'Vezes',
        qrCode: 'Gerar código QR',
        enlarge: 'Expandir / recolher tabela',
        endDate: 'Data de término (permanentemente válida se não for preenchida)',
        trainPlan: 'Programa de treinamento',
        signArea: 'Área de check-in',
        signPoint: 'Ponto de check-in',
        userStatus: 'Status de usuário',
        trainingMode: 'Modo de treinamento',
        currentOrg: 'Organização atualmente selecionada',
        clickOrgFirst: 'Clique na organização à esquerda e selecione o prazo.',
        checkAllMembers: 'Faça o seguinte para todos os membros',
        advancedSettings: 'Configurações avançadas',
        advancedAccount: 'Digite o número da conta do aluno ou o número de trabalho, separados por espaços ou quebras de linha',
        advancedMaxError: 'Por favor, não exceda 1000 contas!',
        extendEndTime: 'Estender a hora de término',
        extendTip1: 'A hora de término não pode ser menor que a data atual',
        extendTip2: 'Cancelando a configuração do horário de término estenderá o programa de treinamento indefinidamente',
        extendRule: 'Regras',
        clonePlan: 'Clonar o programa de treinamento',
        cloneTip1: 'Os estagiários no programa de treinamento não serão clonados',
        cloneTip2: 'Se o nome do programa de treinamento não for preenchido, o nome do programa de treinamento clonado será usado por padrão.',
        cloneSuccess: 'Clonado com sucesso!',
        group: 'Grupo',
        groupManage: 'Gerenciamento de grupo',
        groupName: 'Nome de grupo',
        groupAdd: 'Adicionar grupo',
        groupEdit: 'Editar grupo',
        pushMessage: 'Encaminhar notícias',
        surePushMessage: 'Tem certeza de que deseja enviar mensagens push para este programa de treinamento?',
        pushSuccess: 'Empurre o sucesso da mensagem!'
    },
    course: {
        course: 'Curso',
        name: 'Nome de material didático',
        type: 'Tipo de material didático',
        sectionCannotDisplay: 'O recurso deste capítulo não pode ser exibido temporariamente',
        theoryCourseware: 'Material didático teórico',
        chapter: 'Capítulo',
        theChapter: 'Capítulo {0}', // 重点翻译
        viewing: 'Visualização atual',
        myCourse: 'Meu material didático',
        theoryCoursewareMake: 'Produção de material didático teórico',
        theoryCoursewareEdit: 'Edição de material didático teórico',
        imageCoursewareMake: 'Produção de material didático de imagem',
        imageCoursewareEdit: 'Edição de material didático de imagem',
        imageCourseware: 'Curso de imagem',
        addBaseInfo: 'Adicionar informações básicas',
        addChapter: 'Adicionar capítulo',
        addImage: 'Adicionar imagem',
        courseCover: 'Capa de material didático',
        addCover: 'Capa de material didático',
        deleteCover: 'Excluir capa',
        coverTip: 'Nota: O tamanho da imagem da capa não excede {0}M',
        coverTooBigMsg: 'O tamanho da imagem da capa do upload não pode exceder 2 MB!',
        courseDesc: 'Descrição do material didático',
        courseNoImg: 'Não há imagem no curso atual, clique no botão para adicionar uma imagem.',
        imageName: 'Nome da imagem',
        addImageDesc: 'Adicionar descrição da imagem:',
        addImageDescInfo: 'Por favor, adicione a descrição da imagem ...',
        courseMakeSuccess: 'A produção de material didático foi bem sucedida!',
        curriculumSystem: 'Sistema curricular',
        chapterTitle: 'Digite um título para o capítulo',
        sectionTitle: 'Digite um título de seção',
        resourceSelection: 'Seleção de recursos',
        fileUpload: 'Upload de arquivo',
        fastForward: 'Pode avançar rapidamente',
        noFastForward: 'Não pode avançar rapidamente',
        learningTime: 'Duração do estudo',
        terminateUpload: 'Finalizar upload',
        imageUpload: 'Upload de imagem',
        documentUpload: 'Upload de documento',
        videoUpload: 'Upload de vídeo',
        audioUpload: 'Upload de Áudio',
        fileUploadFail: 'Falha no upload do arquivo. Envie novamente',
        courseEditSuccess: 'O material didático foi modificado com sucesso!',
        marquee: 'Se deseja abrir o carrossel',
        marqueeText: 'Por favor, insira o conteúdo do carrossel',
        min: 'Minuto',
        addTip: 'Nota: Bloqueie o mouse na caixa de entrada do nome do capítulo e clique em Enter para adicionar um capítulo.',
        sectionDes: 'Digite uma descrição desta seção ...'
    },
    topic: {
        name: 'Nome de pergunta de exame',
        examPaperLibrary: 'Banco de pergunta de exame',
        detailView: 'Vista de detalhe',
        listView: 'Vista de lista',
        useTimes: 'Ordenação de número de utilizações',
        rightRateSort: 'Ordenação de taxa correta',
        rightRate: 'Taxa correta',
        default: 'Ordenação padrã',
        papersAssembleTimes: 'Número de composição do papel de teste',
        papersTimesSort: 'Ordenação de número de composição do papel de teste',
        papersAssembled: 'Número de composição do papel de teste feita',
        answerAnalysis: 'Análise de respostas',
        imageDesc: 'Descrição de imagem',
        questionDesc: 'Descrição de pergunta de exame',
        myTopic: 'Minhas perguntas de exame',
        addTopic: 'Adicionar perguntas de exame',
        editTopic: 'Editar perguntas de exame',
        optionDesc: 'Descrição de opção',
        rightOption: 'Opção correta',
        addOrEditAnalyse: 'Adicionar / modificar análise de resposta',
        simulatedBag: 'Pacote analógico',
        emptyPacket: 'Pacote vazio',
        dangerous: 'Mercadorias perigosas',
        chooseImage: 'Selecionar imagem',
        addTopicDesc: 'Clique para adicionar uma análise à resposta ',
        insertTip: 'Inserir TIP (DICA)',
        editSaveSuccess: 'Edição salva com sucesso!',
        passLine: 'Linha de passe',
        mockPassLine: 'Linha de aprovação',
        leastOne: 'Selecione pelo menos uma pergunta',
        addTopicByPic: 'Importar imagem para gerar pergunta de julgamento',
        excelDown: 'Download de modelo do Excel',
        excelImport: 'Importação do Excel',
        wordDown: 'Download do modelo do Word',
        wordImport: 'Importação do Word',
        tipAdjust: 'Ajuste de Tip',
        tipAdjustPanel: 'Painel de controle de ajuste de Tip',
        zoom: 'Zoom',
        rotate: 'Rodar',
        physicalMap: 'Mapa físico',
        attention: 'Precauções',
        tipInsertAttention1: '1. Não dimensione ou gire o Tip inserida no pacote de visão dupla',
        tipInsertAttention2: '2. Se a imagem da Dica (Tip) exceder a imagem do pacote durante o zoom ou a rotação, arraste e ajuste manualmente',
        tipInsertAttention3: '3. Escolha uma faixa razoável para o zoom de Dica (Tip), tente combinar com a situação real',
        answerLabelType: 'Tipo de etiqueta de resposta',
        clickUpload: 'Envio'
    },
    paper: {
        paper: 'Papel de exame',
        myPaper: 'Meu papel de exame',
        theoryPaper: 'Papel de exame teórico',
        theoryPaperMake: 'Produção de papel de teste teórico',
        theoryPaperEdit: 'Edição de papel de teste teórico',
        imagePaper: 'Papel para exame de imagem',
        imagePaperMake: 'Produção de papel para exame de julgamento de imagem',
        imagePaperEdit: 'Edição de papel para exame de julgamento de imagem',
        name: 'Nome do papel de teste',
        type: 'Tipo do papel de teste',
        form: 'Forma do papel de teste',
        paperMethod: 'Modo de composição do papel de teste',
        testPeriod: 'Tempo do exame (minutos)',
        publishTime: 'A hora em que a resposta será anunciada',
        publishTimeTip: 'Se você não escolher, a resposta será publicada imediatamente após o exame',
        allowReview: 'Pode rever para verificar a resposta?',
        allowResit: 'Se é permitido tomar o exame complementar?',
        allowResitTimes: 'Número de exame complementar permitido',
        resatTimes: 'Número de exame complementar feito',
        keyResit:'Maquiagem com um clique',
        resitSuccess: 'Sucesso de maquiagem！',
        leaveTimes: 'Número de muda de tela ',
        disorder: 'Se está fora de serviço',
        questionType: 'Tipo de pergunta',
        single: 'Pergunta de escolha única',
        multiple: 'Pergunta de escolha múltipla',
        trueOrFalse: 'Pergunta de julgamento',
        matching: 'Perguntas correspondentes',
        buildupSmart: 'Composição do papel de teste inteligente',
        buildupChoose: 'Composição do papel de teste de seleção de pergunta',
        buildupImport: 'Importar composição do papel de teste',
        passScore: 'Pontuação de aprovação',
        passingMark: 'Marca de passe',
        totalScore: 'Pontuação total',
        paperLibrary: 'Biblioteca de exames',
        paperScore: 'Pontuação do papel de teste',
        editPaper: 'Editar perguntas de teste',
        startPaper: 'Iniciar a composição do papel de teste',
        randomGenPaper: 'De acordo com as condições da composição do papel de teste, selecione perguntas aleatoriamente no banco de perguntas para gerar um conjunto de papéis de teste',
        chooseGenPaper: 'Marque as perguntas ideais para formar um conjunto de papéis de teste',
        importGenPaper: 'Importar modelos Word e Excel, ou inseri-los manualmente para gerar rapidamente trabalhos de exame',
        chooseImportType: 'Escolha o método de importação',
        wordImport: 'Importação do Word',
        wordUpload: 'Upload Word',
        excelImport: 'Importação do Excel',
        excelUpload: 'Upload Excel',
        clickBtnAddTopic: 'Não há perguntas no documento de teste atual, clique no botão para adicionar as perguntas de teste.',
        addTopic: 'Adicionar perguntas',
        totalQuestions: 'Número total de perguntas',
        totalScores: 'Pontuação total',
        points: 'Marca',
        reimport: 'Reimportar',
        previewPaper: 'Pré-visualização',
        savePaper: 'Salvar',
        answer: 'Resposta',
        analysis: 'Análise',
        keyQuestion: 'Questão chave',
        keyQuestionAccuracy: 'Taxa correta da pergunta chave',
        backToTop: 'Voltar ao topo',
        chooseTopic: 'Selecionar perguntas',
        topicSource: 'Fonte das perguntas',
        source: 'Fonte',
        editPaperSuccess: 'O papel de teste foi modificado com sucesso',
        theoryPaperMakeSuccess: 'O papel de teste teórico foi feito com sucesso',
        imagePaperMakeSuccess: 'O papel de teste de imagem foi feito com sucesso.',
        difficultDistribution: 'Distribuição de dificuldade e simplicidade',
        simple: 'Simples',
        medium: 'Médio',
        hard: 'Difícil',
        questionQuantity: 'Quantidade',
        scorePerQuestion: 'Pontuação por pergunta',
        singleTotalNum: 'Perguntas de única escolha (total {0})',
        multipleTotalNum: 'Perguntas de múltipla escolha (total {0})',
        judgeTotalNum: 'Pergunta de julgamento (total {0})',
        knowledgeTotalNum: 'Pontos de conhecimento (total {0})',
        emptyPacketTotalNum: 'Pacote vazio (total {0})',
        otherTotalNum: 'Outro (total {0})',
        selectYourTopic: 'Selecione {0} perguntas',
        paperNumGtOne: 'O documento do exame deve conter pelo menos uma pergunta de exame',
        paperNeddIncludeOneKP: 'O documento do exame deve conter pelo menos uma pergunta de exame do ponto de conhecimento',
        smartGroupSuccess: 'Composição do papel de teste inteligente foi feita com sucesso',
        imageTopic: 'Pergunta de imagem',
        dao: 'Perguntas',
        eachTopic: 'Cada pergunta',
        setKeyTopic: 'Definir perguntas-chave',
        accuracyRate: 'Taxa correta',
        buildupFast: 'Composição do papel de teste rápida',
        tipGenPaper: 'Inserir automaticamente a DICA(TIP) para gerar rapidamente papéis de teste',
        safeBag: 'Pacote seguro',
        selectKPTip: 'Clique à direita para selecionar o tipo de ponto de conhecimento',
        ge: 'Unidade',
        emptyNum: 'Número de pacote vazio',
        dangerNum: 'Número de mercadorias perigosas',
        simulatedNum: 'Número simulado de pacotes',
        warnEmpty: 'Digite o número de pacotes seguros',
        showAnswerAfterExam: 'Anunciar após o teste',
        mock: 'Teste de simulação',
        mockTimes: 'Número de teste de simulação',
        chooseKpFirst: 'Por favor, selecione o tipo de ponto de conhecimento primeiro.',
        exportPaper: 'Exportar papel de teste',
        imgSourceTip: 'Por favor, selecione uma fonte de imagem'
    },
    // 全屏的考试/练习页
    exam: {
        totalCount: 'Este papel de teste contém',
        question: 'Perguntas',
        min: 'Minuto',
        score: 'Grau',
        period: 'Tempo de resposta',
        answerSheet: 'Cartão de resposta',
        singleMode: 'Modo de pergunta única',
        multiMode: 'Modo de perguntas múltiplas',
        correct: 'Correto',
        incorrect: 'Incorreto',
        answered: 'Respondida',
        blank: 'Sem resposta',
        viewAnswer: 'Ver a resposta',
        prev: 'Pergunta anterior',
        next: 'Próxima pergunta',
        submit: 'Finalizar resposta',
        practiceTitle: 'Prática teórica',
        loading: 'Carregando ...',
        result: 'Resultado de exame',
        practiceResult: 'Resultado da prática',
        paperCount: 'Este papel de teste tem um total de',
    },
    //图库、资源管理
    res: {
        imgName: 'Nome de imagem',
        imgType: 'Tipo de imagem',
        imgDesc: 'Descrição de imagem',
        perspective: 'Perspectiva',
        singleView: 'Perspectiva única',
        doubleView: 'Perspectiva dupla',
        sideView: 'Perspectiva dupla',
        imgOrigin: 'Fonte de imagem',
        file: 'Ficheiro',
        fileView: 'Visualização de ficheiro',
        listView: 'Visualização de lista',
        viewCT: 'Ver CT',
        viewDR: 'Ver DR',
        lastFile: 'Ficheiro anterior',
        nextFile: 'Ficheiro seguinte',
        editImg: 'Modificar informações de imagem',
        resName: 'Nome de recurso',
        resType: 'Tipo de recurso',
        checkAll: 'Selecionar tudo',
        cancelCheckAll: 'Cancelar toda a seleção',
        allFiles: 'Todos os arquivos',
        upload: 'Carregar',
        uploadTime: 'Hora do upload',
        rename: 'Renomear',
        progress: 'Executando ...',
        renameSuccess: 'Renomeado com sucesso',
        newFolder: 'Nova pasta',
        folderNameTip: 'Digite o nome de pasta',
        folderNameIs: 'O nome da pasta é:',
        newFolderSuccess: 'Criado com sucesso!',
        uploadStep: 'Processo de upload',
        success: 'Upload com sucesso',
        error: 'Falha no upload',
        uploading: 'Carregando',
        paused: 'Suspenso',
        waiting: 'Aguardando upload',
        delete: 'Excluir',
        fileList: 'Lista de arquivos',
        chooseFile: 'Selecionar arquivo',
        expand: 'Expandir',
        fold: 'Dobra',
        noUploadFile: 'Nenhum arquivo aguardando upload',
        checkMD5: 'Verificar MD5',
        transcoding: 'Transcodificando',
        merging: 'Mesclando',
        uploadFail: 'Falha no upload',
        copyTo: 'copiar para',
        moveTo: 'mover para',
        refresh: 'Atualizar',
        fileTotal: 'Total de {0} arquivos',
        fileSize: 'Tamanho do arquivo',
        playAudio: 'Tocar áudio',
        syncToLibrary: 'Sincronizar com a biblioteca de imagens',
        bag: 'Pacote',
        editImage: 'Modificar imagem',
        isTip: 'Se é um único produto perigoso',
        isDeleteAfterTB: 'Se deseja excluir imagens',
        synchSuccess: 'A sincronização foi bem sucedida!',
        deleteMulti: 'Tem certeza de que deseja excluir esses {0} arquivos?',
        fiscanImage: 'Detalhes das estatísticas da imagem Fiscan',
        nuctechImage: 'Detalhes das estatísticas da imagem Nuctech',
        copy: 'Copiar imagem',
        move: 'Imagem em movimento',
        selected: 'Selecionado {0}',
        standardLib: 'Galeria Padrão',
        userLib: 'Galeria pessoal',
        addNode: 'Adicionar nó',
        shareFrom: 'Compartilhe de {share}',
        editNode: 'Editar nó',
        addChildNode: 'Adicionar nó filho',
        nodeName: 'Nome do nó',
        nodeType: 'Tipo de nó',
        folder: 'Pasta',
        imgFile: 'Pasta de imagem',
        selectImgFile: 'Por favor, selecione uma pasta de imagens',
        selectMember: 'Escolha uma pessoa',
        moveSuccess: 'Sucesso móvel！',
        copySuccess: 'Cópia bem sucedida！',
        shareSuccess: 'Compartilhe o sucesso！',
        sureDelFile: 'Tem certeza de que deseja excluir {file}？',
        sureDelImgFile: 'Tem certeza de que deseja excluir {file}？ Se excluídas, as imagens contidas na pasta de imagens também serão excluídas.',
        currentCheckNode: 'Posição atual da imagem',
        checkNodeTip: 'Clique na pasta da imagem à esquerda',
        addKnowledge: 'Adicione conhecimento',
        knowName: 'Nome do conhecimento',
        knowType: 'Categoria de conhecimento',
        knowTag: 'Etiqueta de conhecimento',
        knowDesc: 'Descrição do conhecimento',
        pageViews: 'Visualizações de página',
        comments: 'Volume de comentários',
        likes: 'Curtidas',
        allSee: 'Todos podem ver',
        someSee: 'Algumas pessoas podem ver',
        uploader: 'Uploader',
        visibleRange: 'Definir faixa visível',
        knowTagTip: 'Tags são ferramentas fáceis de encontrar e gerenciar. Separe várias tags com vírgulas',
        visiblePerson: 'Pessoas visíveis',
        updateSystemTree: 'Atualizar biblioteca de imagens padrão',
        noAccessToDelete: 'Sem permissão para excluir todas as imagens selecionadas',
        filterDelete: '{0} imagens excluídas sem permissão serão filtradas automaticamente'
    },
    cert: {
        holder: 'Detentor de certificado',
        type: 'Tipo de certificado',
        date: 'Data',
        number: 'Número',
        issueDate: 'Data de emissão',
        reviewDate: 'Data de revisão',
        retrainDate: 'Data de treinamento recorrente',
        releaseDate: 'Data de lançamento de certificado',
        obtainDate: 'Data da coleta de certificado',
        addCert: 'Adicionar certificado',
        downCertTemp: 'Baixar modelo de certificado',
        upLoadCertTemp: 'Importar certificado',
        upLoadCertPic: 'Importar foto de certificado',
        exportCertTemp: 'Exportar certificado',
        downCertRetrain: 'Baixar modelo de treinamento recorrente',
        upLoadCertRetrain: 'Importar registros de treinamento recorrente',
        editCert: 'Editar certificado',
        dangerCert: 'Certificado de mercadorias perigosas',
        proCert: 'Certificado de qualificação profissional',
        juniorProCert: 'Certificado de qualificação profissional júnior',
        IntermediateProCert: 'Certificado de qualificação profissional intermediária ',
        seniorProCert: 'Certificado de qualificação profissional avançada',
        technicianProCert: 'Certificado de qualificação profissional técnica',
        technicianProPlusCert: 'Certificado de qualificação profissional técnica',
        certManage: 'Gerenciamento de certificado',
        certAddTip: 'Adicionar um certificado a esta pessoa',
        certAddTip_1: 'Por favor, adicione um certificado para esta pessoa no lado esquerdo',
        howToTip: 'Selecione um titular no lado esquerdo e adicione um certificado a ele',
        selectHolderTip: 'Por favor, selecione um titular',
        certInfo: 'Detalhes do certificado',
        certName: 'Nome do certificado',
        certNum: 'Número do certificado',
        theoryScore: 'Realização teórica',
        operationScore: 'Pontuação operacional',
        gradeName: 'Avaliação da nota',
        retrain: 'Treinamento recorrente',
        retrainRecord: 'Registro de treinamento recorrente',
        retrainGrade: 'Resultados de treinamento recorrente',
        obtainCert: 'Certificado obtido',
        trainSubject: 'Curso de treinamento',
        trainInstitution: 'Instituição de treinamento',
        trainerName: 'Nome do instrutor',
        personType: 'Categoria pessoal',
        trainConclusion: 'Conclusão da avaliação',
        qualified: 'Qualificado',
        good: 'Bom',
        excellent: 'Excelente',
        addRecord: 'Adicionar registro',
        editRecord: 'Editar registro',
        selectUser: 'Selecionar um usuário',
        junior: 'Júnior',
        Intermediate: 'Intermediário',
        senior: 'Avançado',
        technician: 'Técnico\n',
    },
    count: {
        quantity: 'Quantidade',
        certMember: 'Detalhes do titular de certificação',
        viewType: 'Tipo de perspectiva',
        singleView: 'Perspectiva única',
        dualView: 'Perspectiva dupla',
        frequency: 'Número de utilizações',
        resType: 'Tipo de recurso',
        uploadRank: 'Classificação de quantidade de upload',
        uploadNum: 'Quantidade de upload',
        courseNum: 'Número de material didático',
        theory: 'Teoria',
        topicType: 'Tipo de pergunta',
        topicDetail: 'Detalhes de pergunta',
        topicNo: 'Número de pergunta',
        examName: 'Nome de exame',
        examDuration: 'Tempo de exame',
        score: 'Pontuação',
        peopleNum: 'Número de pessoas',
        totalPeopleNum: 'Número total de pessoas',
        passRate: 'Taxa de aprovação',
        passScore: 'Pontuação de aprovação',
        averageScore: 'Pontuação média',
        lowest: 'Pontuação mais baixa',
        highest: 'Pontuação mais alta',
        examAttend: 'Participou do exame',
        attend: 'Atendeu o exame',
        examRealAttend: 'Realmente atendido',
        absent: 'Ausente',
        examAbsence: 'Ausente',
        passed: 'Aprovado',
        examPassNum: 'Número do passe',
        failed: 'Falhou',
        examFailNum: 'Número da falha',
        countAnalysis: 'Análise estatística',
        paperScoreStatistic: 'Estatísticas da pontuação do trabalho de teste',
        examDetailTitle: 'Quadro de detalhes do exame',
        wrongRateTitle: 'Estatísticas da taxa de erro de perguntas de teste',
        rightNum: 'Número de perguntas corretas',
        wrongNum: 'Número de perguntas erradas',
        wrongRate: 'Taxa de erro',
        scoreRank: 'Realização de aluno',
        transcript: 'Transcrição',
        exportStuDetail: 'Exportar detalhes da resposta do aluno',
        exportTranscript: 'Exportar transcrição',
        exportOffline: 'Exportar lista de treinamento',
        print: 'Imprimir',
        printReview: 'Imprimir visualização',
        exportDate: 'Exportar data',
        timeConsume: 'Tempo usado',
        submitTime: 'Hora de envio',
        ranking: 'Ranking',
        rankStatisticsTitle: 'Estatísticas de classificação de pontuação',
        rankRangeTitle: 'Estatísticas de distribuição de pontuação',
        feedback: 'Feedback de pesquisa',
        trainDetailTitle: 'Estatísticas de detalhes de treinamento',
        numStatistics: 'Estatísticas de quantidade',
        studyDuration: 'Tempo de aprendizagem',
        studyTime: 'Duração de estudo',
        studyNum: 'Número total de estudos',
        min: 'Minuto',
        s: 'Segundo',
        personalStudyTitle: 'Estatísticas de aprendizagem pessoal',
        finish: 'Terminado',
        unfinish: 'Inacabado',
        notStart: 'Não iniciado',
        processing: 'Em andamento',
        absence: 'Ausente',
        recover: 'Recuperação',
        registered: 'Registado',
        normal: 'Normal',
        late: 'Atrasado',
        error: 'Anormal',
        studentStatus: 'Estado',
        knowErrorRate: 'Taxa de erro do ponto de conhecimento',
        knowErrorRateStat: 'Estatísticas da taxa de erro do ponto de conhecimento',
    },
    survey: {
        name: 'Nome de pesquisa',
        add: 'Adicionar questionário de pesquisa',
        edit: 'Editar questionário de pesquisa',
        desc: 'Descrição de pesquisa',
        topic: 'Tópico de pesquisa',
        addOption: 'Adicionar opção',
        addTitleTip: 'Clique aqui para adicionar um tópico',
        subjective: 'Pergunta subjetiva',
        star1: 'Muito insatisfeito',
        star2: 'Insatisfeito',
        star3: 'Ordinário',
        star4: 'Satisfeito',
        star5: 'Muito satisfeito',
        responseNum: 'Número de respondentes',
        percentage: 'Percentagem',
        detail: 'Detalhe do questionário',
        statisticsTitle: 'Estatísticas do questionário de pesquisa de treinamento',
        publisher: 'Promulgador',
        validNum: 'Número de respostas efetivas',
        satisfaction: 'Satisfação geral',
        proportion: 'Proporção',
        synthesis: 'Abrangente',
        appraised: 'Não avaliado (0)',
        average: 'Pontuação média:'
    },
    questionnaire: {
        name: 'Nome de pesquisa',
        add: 'Adicionar questionário de pesquisa',
        edit: 'Editar questionário de pesquisa',
        desc: 'Descrição de questionário',
        topic: 'Tópico',
        starTopic: 'Pergunta de classificação',
        startSurvey: 'Iniciar investigação',
        peopleNum: 'Número de participantes',
        defaultReport: 'Relatório padrão',
        replyStatistics: 'Estatísticas de respostas',
        NO: 'Pergunta {0}',
        filterEmpty: 'Filtrar opção vazia',
        replyTime: 'Tempo de resposta',
        replyTxt: 'Texto de resposta',
        viewPaper: 'Ver folha de respostas',
        startSuccess: 'Lançado com sucesso!',
        maxLimit: 'Selecione até {0} itens',
        open: 'Abrir questionário',
        close: 'Fechar questionário',
        export: 'Exportar questionário',
        confirmOpen: 'Você tem certeza de abrir o questionário?',
        confirmClose: 'Você tem certeza de fechar o questionário?',
        successOpen: 'Aberto com sucesso!',
        successClose: 'Fechado com sucesso!',
    },
    // 学员模块
    stu: {
        unfinished: 'Inacabado',
        finished: 'Concluído',
        studyProgress: 'Progresso da aprendizagem',
        viewCourse: 'Ver material didático',
        enterStudy: 'Iniciar a aprendizagem',
        continueStudy: 'Continue a aprender',
        viewPaper: 'Ver documento do exame',
        enterExam: 'Entrar no exame',
        continueExam: 'Continue o exame',
        enterMock: 'Entrar no exame simulado',
        startResit: 'Iniciar exame complementar',
        resitStatus: 'Estado de exame complementar',
        resat: 'Já fez o exame complementar',
        allowResit: 'Permitir exame complementar',
        loadingExamTip: 'Carregando o papel de teste ...',
        serverError: 'O servidor está falhado ~',
        loadPaperError: 'Falha no carregamento dos dados do papel de teste!',
        topicNum: 'Número de perguntas',
        startPractice: 'Começar a praticar',
        startStudy: 'Começar a estudar',
        timeSetting: 'Ajuste de tempo',
        set: 'Configurar',
        notSet: 'Não configurar',
        singleTopic: 'Pergunta única',
        wholePaper: 'Papel de exame inteiro',
        practiceMode: 'Modo de prática',
        quickJudge: 'Julgamento rápido',
        markLocation: 'Marcar localização',
        markLocationAndJudge: 'Marca de localização e seleção de tipo',
        pass: 'Passe',
        passed: 'Aprovado',
        failed: 'Falhou',
        passRate: 'Taxa de aprovação',
        theoryPractice: 'Prática teórica',
        imgPractice: 'Prática de imagem',
        practiceDate: 'Tempo de prática',
        timeoutNum: 'Número do tempo limite',
        trainTask: 'Tarefa de treinamento',
        personal: 'Estatísticas resumidas',
        trainNum: 'Número de treinamentos',
        testNum: 'Número de exercícios',
        exciseNum: 'Número de exercícios',
        imageNum: 'Número de identificação de imagens',
        errorStatistics: 'Estatísticas de perguntas incorretas',
        isPass: 'Estado de passe',
        testPass: 'Estatísticas de resultado de exame',
        courseStudy: 'Estatísticas de aprendizado do material didático',
        imageAbility: 'Análise de capacidade de reconhecimento de imagem',
        theoryKP: 'Ponto de conhecimento teórico',
        imageKP: 'Ponto de conhecimento de imagem',
        taskName: 'Nome de tarefa',
        intoTask: 'Entrar na missão',
        imgPracticeTip1: '1. O modo de julgamento rápido pode usar diretamente as teclas de atalho [>], [?] para executar o julgamento de imagem de "aprovado" ou "não aprovado"',
        imgPracticeTip2: '2. No modo de prática de julgamento não rápido, o julgamento de imagem é "perigoso" e só pode ser julgado marcando manualmente o suspeito.',
        imgPracticeTip3: '3. Após definir a opção de resposta não pode ser modificada, só pode julgar imagens ativadas (com pontos piscando)',
        imgPracticeTip4: '4. A imagem anterior não será mantida durante o processo de desenho e a operação de modificação da resposta não é suportada para a imagem excluída.',
        imgPracticeTip5: '5. Mudança de velocidade [1, 2, 3], clique duas vezes no tamanho do quadro de suspeita marcado para mudar [z, x, c], pausar o interruptor de início [espaço] para mudar',
        walkingPictureSetting: 'Configuração do processo de desenho',
        answerCanModify: 'A resposta pode ser modificada',
        answerCannotModify: 'A resposta não pode ser modificada',
        slow: 'Mais lento',
        normal: 'Normal',
        fast: 'Mais rápido',
        suspectColor: 'Cor do quadro',
        speed: 'Velocidade do processo de desenho',
        pracitceNote: 'Atenção de prática',
        theoryAndImgPractice: 'Exercícios de teoria e ilustração',
        continuePractice: 'Continuar praticando',
        newPractice: 'Iniciar novo exercício',
        unsubmitPracticeTip: 'Os dados da prática atual não foram enviados. Deseja continuar o exercício atual?',
        imgStudyMenu: 'Aprendizagem de conhecimento de imagem',
        imgPracticeMenu: 'Prática de conhecimento de imagem',
        trackPracticeMenu: 'Prática de processo de desenho',
        submitDate: 'Data de envio',
        images: 'Número de imagens',
        resultpf: 'Resultado',
        historyMockPaper: 'Papel de exame histórico',
        enterExamTip: 'Uma vez que o exame começa, desistir no meio do curso pode resultar em nenhuma nota, por favor, prepare-se para o exame.',
        creditsEarned: 'Credits earned',
        totalCredit: 'Créditos totais',
        monthCredit: 'Créditos do mês',
        allRank: 'Todas as classificações',
        orgRank: 'Ranking da Instituição',
        creditDetail: 'Detalhes de crédito',
        watchCreditDetail: 'Ver detalhes de crédito',
        rankList: 'Entre os melhores',
        watchRankList: 'Veja a tabela de classificação',
        myCreditRecord: 'Meu registro de crédito',
        rank: 'Classificação',
        noRank: 'Sem classificação'
    },
    prejob: {
        colorBlind: 'Cegueira e fraqueza das cores',
        colorSensitive: 'Sensibilidade da cor',
        spatialIntelligence: 'Imaginação espacial',
        basicKnowledge: 'Conhecimento básico',
        dailyItems: 'Itens diários',
        dangerItems: 'Mercadorias perigosas',
        testTip: 'Lembrete de teste',
        startTest: 'Iniciar teste',
        quitTest: 'Desistir teste',
        submitTest: 'Enviar teste',
        tipDoNotClose: 'Dicas: Não feche a página do exame durante o processo de resposta.',
        tipOneChance: 'Apenas uma oportunidade de teste, por favor, leve a sério ~',
        forReference: 'Nota: Este resultado do teste não representa autoridade',
        tipProgress: 'Conclua todos os testes para ver os resultados da avaliação',
        cheerUp: 'Vamos lá!',
        viewReport: 'Exibir relatório de avaliação',
        reportTitle: 'Relatório de avaliação inteligente',
        rating: 'Nível de avaliação',
        weakness: 'Ponto de conhecimento fraco',
        accuracy: 'Taxa de resposta positiva',
        assessTitle: 'A plataforma analisou os seguintes resultados com base nos seus dados de avaliação.',
        assessPerfect: 'Você é perfeito em {0}',
        assessGood: 'Você tem uma compreensão básica de {0}',
        assessBad: 'Você não é bom em {0}, precisa fazer esforços',
        assessCheerUp: 'Vamos lá, você vai se tornar um bom inspetor de segurança ~',
        notDone: 'A avaliação pré-emprego ainda não foi concluída'
    },
    http: {
        error: 'Anomalia de rede',
        forbidden: 'Sem acesso',
        serverError: 'Exceção do servidor',
        timeout: 'Tempo limite da solicitação'
    },
    app: {
        login: 'Entrar',
        portal: 'Portal',
        mobileSite: 'Login para celular',
        switchTheme: 'Alternar estilo de tema',
        signOut: 'Sair',
        changePwd: 'Alterar senha',
        oldPwd: 'Senha antiga',
        newPwd: 'Nova senha',
        confirmPwd: 'Confirmar a nova senha',
        errorPwd: 'As duas senhas são inconsistentes!',
        bindMobile: 'Vincular celular',
        mobile: 'Número de celular',
        code: 'Código de verificação',
        getCode: 'Obter código de verificação',
        getCodeAgain: 'Recuperar',
        waitCode: 'Recuperar após {0} s',
        bound: 'Você já vinculou o número de celular',
        unbound: 'O número de telefone não está vinculado ao usuário',
        untie: 'Desvincular',
        errorMobile: 'Digite o número de celular correto',
        bindSuccess: 'Vinculado com sucesso!',
        untieSuccess: 'Desvinculado com sucesso!',
        account: 'Digite um número de conta ou número de celular',
        jobNo: 'Digite o número do trabalho',
        enterpriseCode: 'Por favor, indique a empresa codificado',
        roleType: 'Por favor, selecione um tipo de identidade',
        admin: 'Admin',
        trainer: 'Instrutor',
        student: 'Estudante',
        pwd: 'Digite sua senha',
        logining: 'Fazendo login',
        loginNow: 'Fazer login agora',
        forgetPwd: 'Esqueceu sua senha?',
        retrievePwd: 'Recuperar senha',
        pwdLogin: 'Login e Senha',
        scanLogin: 'Login de código de verificação',
        smsLogin: 'SMS',
        jobNoLogin: 'Número do trabalho',
        faceLogin: 'Reconhecimento de retrato',
        faceLoginClick: 'Clique para executar o login de reconhecimento de retrato',
        confirmEdit: 'Confirmar modificação',
        resetSuccess: 'Sua senha foi redefinida e passará automaticamente para a tela de login após {0} s',
        scanSuccess: 'Digitalizando código com sucesso',
        qrInvalid: 'O código QR expirou',
        freshQR: 'Atualizar código QR',
        scanLoginTip: 'Digitalize o código QR para fazer login',
        appName: 'Nuctech',
        dashboard: 'Página inicial',
        track: {
            trackTip: 'Não atualize ou feche a página durante o processo de detecção. É recomendável manter os recursos faciais claros.',
            envMonitoring: 'Monitorando o meio ambiente...',
            faceMonitoring: 'No monitoramento de retrato, olhe para a câmera',
            liveMonitoring: 'Sucesso na captura de retrato, verificando o corpo vivo…',
            camera: 'Tirar uma foto após {0} segundos, continue assistindo',
            checking: 'Verificando...',
            loginSuccess: 'Entrar com sucesso!'
        },
        copyright: '©2019, NUCTECH COMPANY LIMITED. All Rights Reserved',
    }
}
